// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".fef98fcff5f7a0cf3c1db1d90ed924e6f551b2ef.chunk.bundle.js";
};